import "core-js/modules/web.dom.iterable";
//
//
//
//
import barLineChart from '@/components/bigDataChart/barLineChart'; // import { querySewageQuota } from '@/api/api'

import { queryWarnAnalysis } from '@/api/api';
export default {
  name: 'warnStatistics',
  created: function created() {
    this.queryWarnStatistics();
  },
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    }
  },
  components: {
    barLineChart: barLineChart
  },
  methods: {
    queryWarnStatistics: function queryWarnStatistics(areaId, projectId) {
      var _this = this;

      var that = this;
      var yAxisData1 = [];
      var yAxisData2 = [];
      var yAxisData3 = [];
      var xAxisData = [];
      queryWarnAnalysis({}).then(function (res) {
        if (res.success) {
          res.result['1'].forEach(function (element) {
            yAxisData1.push(element.warnSum);
            xAxisData.push(element.dateStr);
          });
          res.result['2'].forEach(function (element) {
            yAxisData2.push(element.warnSum);
          });
          res.result['3'].forEach(function (element) {
            yAxisData3.push(element.warnSum);
          });
          var data = {
            color: ['#8B5CFF', '#00CA69', '#898b37'],
            title: ['数据预警', '设备预警', '离线预警'],
            xAxisData: xAxisData,
            yAxisList: [yAxisData1, yAxisData2, yAxisData3],
            unit: '次'
          };

          _this.$refs.chart2.initBarLineChart(data);
        }
      });
    }
  } //   watch: {
  //     currentProjectId(value) {
  //       this.queryWarnStatistics(this.currentAreaId, value)
  //     },
  //     currentAreaId(value) {
  //       this.queryWarnStatistics(value, this.currentProjectId)
  //     },
  //   },

};